import React from 'react';
import PropTypes from 'prop-types';
import Button from 'reactstrap/lib/Button';
import { getCoreUrl } from 'site-modules/shared/utils/core-link-constructor';

const LABEL_NAME = 'Read full review';

export function EdmundsRatingButton({
  buttonColor = 'outline-primary-b',
  className = 'px-0_5 px-lg-1 mx-1',
  makeSlug = null,
  modelSlug = null,
  year = null,
  oemEdmundsReviewLink = null,
  trackingId = null,
  toReviewPage = false,
  makeName = null,
  modelName = null,
}) {
  if (!(makeSlug && modelSlug && year)) {
    return null;
  }

  const reviewUrl = `${getCoreUrl({ makeSlug, modelSlug, year }, toReviewPage)}#subnav-reviews`;
  const ymmName = `${year} ${makeName} ${modelName}`;

  return (
    <Button
      className={className}
      color={buttonColor}
      tag="a"
      rel={oemEdmundsReviewLink ? '' : 'nofollow'}
      href={oemEdmundsReviewLink || reviewUrl}
      data-tracking-id={trackingId}
      aria-label={`${LABEL_NAME} for ${ymmName}`}
    >
      {LABEL_NAME}
    </Button>
  );
}

EdmundsRatingButton.propTypes = {
  buttonColor: PropTypes.string,
  className: PropTypes.string,
  makeSlug: PropTypes.string,
  modelSlug: PropTypes.string,
  year: PropTypes.number,
  oemEdmundsReviewLink: PropTypes.string,
  trackingId: PropTypes.string,
  toReviewPage: PropTypes.bool,
  makeName: PropTypes.string,
  modelName: PropTypes.string,
};
